import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const preApprovedVisitorList = createAsyncThunk('preApprovedVisitor/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `pre_approved_visitor`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'gate_id': data?.gate_id,
                'type_id': data?.type_id,
                'sub_type_id': data?.sub_type_id,
                'validity': data?.validity,
                'type': data?.type,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const preApprovedVisitorDetails = createAsyncThunk('preApprovedVisitor/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `pre_approved_visitor/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addPreApprovedVisitor = createAsyncThunk('preApprovedVisitor/add', async (data) => {
    try {
        let adminFlag = ''
        try {
            const role = JSON.parse(SessionManager.getCookie('role') || '{}')
            const roleName = String(role?.role_name || '')
            adminFlag = /admin/i.test(roleName) ? 'true' : ''
        } catch {
            adminFlag = ''
        }

        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'pre_approved_visitor',
            data: {
                "premise_id": data?.values?.premise_id,
                "gate_id": data?.values?.gate_id,
                "user_name": data?.values?.visitor_name,
                "user_mobile": data?.values?.mobile_number,
                "type_id": data?.values?.type,
                "sub_type_id": data?.values?.sub_type,
                "unit_id": data?.values?.unit_id,
                "validity": data?.values?.validity && moment(data?.values?.validity, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "visit_time": data?.values?.visit_time,
                "member": data?.values?.people_allowed,
                "description": data?.values?.purpose,
                "user_vehicle": data?.values?.vehicle_number,
                "admin": adminFlag,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updatePreApprovedVisitor = createAsyncThunk('preApprovedVisitor/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'pre_approved_visitor',
            data: {
                "pre_approved_id": data?.values?.id,
                "premise_id": data?.values?.premise_id,
                "gate_id": data?.values?.gate_id,
                "user_name": data?.values?.visitor_name,
                "user_mobile": data?.values?.mobile_number,
                "type_id": data?.values?.type,
                "sub_type_id": data?.values?.sub_type,
                "unit_id": data?.values?.unit_id,
                "validity": data?.values?.validity && moment(data?.values?.validity, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "visit_time": data?.values?.visit_time,
                "member": data?.values?.people_allowed,
                "description": data?.values?.purpose,
                "user_vehicle": data?.values?.vehicle_number,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delPreApprovedVisitor = createAsyncThunk('preApprovedVisitor/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `pre_approved_visitor/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const preApprovedVisitor = createSlice({
    name: 'preApprovedVisitor',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(preApprovedVisitorList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(preApprovedVisitorDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default preApprovedVisitor.reducer;